import * as ko from "knockout"

export class ElementLocationViewModel {
    rowSpan: KnockoutObservable<number>;
    columnSpan: KnockoutObservable<number>;
    options: KnockoutObservableArray<number>;

    isLink: KnockoutObservable<boolean>;
    link: KnockoutObservable<string>;

    constructor(public elementType: string) {
        this.rowSpan = ko.observable(1);
        this.columnSpan = ko.observable(1);

        this.options = ko.observableArray([]);
        for (var i = 1; i <= 50; i++) {
            this.options.push(i);
        }

        this.isLink = ko.observable(false);
        this.link = ko.observable("");
    }

    setColumnSpan(span: number) {
        const max: number = this.options()[this.options().length - 1];
        this.columnSpan(Math.max(1, Math.min(max, span)));
    }

    setRowSpan(span: number) {
        const max: number = this.options()[this.options().length - 1];
        this.rowSpan(Math.max(1, Math.min(max, span)));
    }

    protected elementMostLikelyChangedSize: () => void;

    protected onSetElementMostLikelyChangedSize() {

    }

    public setElementMostLikelyChangedSize(elementMostLikelyChangedSize: () => void) {
        this.elementMostLikelyChangedSize = elementMostLikelyChangedSize;
        this.onSetElementMostLikelyChangedSize();
    }

    protected cloneThis(o: ElementLocationViewModel) {
        o.elementType = this.elementType;
        o.rowSpan(this.rowSpan());
        o.columnSpan(this.columnSpan());
        o.isLink(this.isLink());
        o.link(this.link());
    }

    public clone(): ElementLocationViewModel {
        let ret = new ElementLocationViewModel(this.elementType);
        this.cloneThis(ret);
        return ret;
    }

    public getData(data): any {
        data.elementType = this.elementType;
        data.rowspan = this.rowSpan;
        data.columnSpan = this.columnSpan;
        data.isLink = this.isLink;
        data.link = this.link;
    }
}



// WEBPACK FOOTER //
// ./code/ElementLocationViewModel.ts